import { render, staticRenderFns } from "./piLiangShouKuan.vue?vue&type=template&id=1bfd27c2&scoped=true&"
import script from "./piLiangShouKuan.vue?vue&type=script&lang=js&"
export * from "./piLiangShouKuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd27c2",
  null
  
)

export default component.exports